import React from "react";
import { FormGroup, Label, Input as BSInput, CustomInput, FormFeedback } from "reactstrap";


const Input = props => {
  const { input, options, label, custom, id, meta = {}, forwardedRef, ...rest } = props;
  return (
    <FormGroup>
      {!custom && label && <Label htmlFor={id}>{label}</Label>}
      {custom ?
        <CustomInput
          dir="ltr"
          type={custom}
          label={label}
          id={id}
          checked={options ? options.indexOf(input.value) === 0 : input.checked}
          onChange={e => {
            if (options) {
              return input.onChange(e.target.checked ? options[0] : options[1])
            }
            return input.onChange(e);
          }}
        />
        :
        <BSInput
          id={id}
          {...input}
          {...rest}
          invalid={meta.error && meta.touched}
          innerRef={node => {
            if (node && typeof forwardedRef === 'function') forwardedRef(node);
          }}
        >
          {options}
        </BSInput>
      }
      {meta.error && meta.touched && <FormFeedback>{meta.error}</FormFeedback>}
    </FormGroup>
  )
}

export default React.forwardRef((props, ref) => <Input {...props} forwardedRef={ref} />)